<template>
  <v-app id="vapp">
    <!--version 0.9.02-->
    <!--//@*/*
    //    *RPD  Appv0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <v-overlay opacity="0.97" :z-index="zIndex" :value="overlay">
      <v-progress-circular
        :size="50"
        style="z-index: 5200"
        color="deep-orange accent-2"
        indeterminate
      >
      </v-progress-circular>
    </v-overlay>

    <brandbar></brandbar>
    <v-main id="main">
      <Transition name="fade-transition" mode="out-in">
        <router-view />
      </Transition>
    </v-main>
  </v-app>
</template>

<style>
.v-main {
  padding: 5px 0 0 0 !important;
}

#vapp {
  background-color: var(--v-background-base);
  overflow-y: auto;
  max-height: 100dvh;
  height: 100dvh;
}

.swal2-popup {
  /* font-size: 1.15rem !important;*/
  font-family: "Roboto", sans-serif !important;
}

@media only screen and (max-width: 600px) {
  #vapp {
    max-height: 100dvh;
  }
}

.v-btn--active.no-active::before {
  opacity: 0 !important;
}

.v-btn--active.no-active:not(:hover)::before {
  opacity: 0 !important;
}
</style>

<script>
import brandbar from "./brandbar";
import { bus_common } from "../mixins/bus_common";
export default {
  name: "App",
  mixins: [bus_common],
  components: { brandbar },

  data() {
    return {
      zIndex: 4000,
    };
  },
  watch: {
    "$store.state.loader_visible": function () {
      //console.log("app loader_visible " + this.$store.state.loader_visible );
    },
  },
  computed: {
    overlay: function () {
      return this.$store.state.loader_visible;
    },
    overlay_prn: function () {
      return this.$store.state.overlay_prn_show;
    },
  },
  methods: {
    logout() {
      this.swall_diag(
        "Log Out?",
        "Are you sure you would like to log out?",
        "question",
        null,
        "Yes",
        "No",
        null
      );
    },
  },
  created() {
    this.show_loader(true);
  },
};
</script>
